import { render, staticRenderFns } from "./AccountEditor.vue?vue&type=template&id=89c1159c"
import script from "./AccountEditor.vue?vue&type=script&lang=ts"
export * from "./AccountEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports